var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorSignupClrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.5506 15.4421C14.8439 15.4421 15.8923 14.3937 15.8923 13.1005C15.8923 11.8072 14.8439 10.7588 13.5506 10.7588C12.2574 10.7588 11.209 11.8072 11.209 13.1005C11.209 14.3937 12.2574 15.4421 13.5506 15.4421Z",
    stroke: "#32AAAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.8746 20.8336C17.8746 18.892 15.9413 17.3086 13.5496 17.3086C11.1579 17.3086 9.22461 18.8836 9.22461 20.8336",
    stroke: "#32AAAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4993 14.4167C21.4993 18.7917 17.9577 22.3333 13.5827 22.3333C9.20768 22.3333 5.66602 18.7917 5.66602 14.4167C5.66602 10.0417 9.20768 6.5 13.5827 6.5C14.6743 6.5 15.716 6.71666 16.666 7.11666C16.5577 7.44999 16.4993 7.8 16.4993 8.16667C16.4993 8.79167 16.6744 9.38333 16.9827 9.88333C17.1494 10.1667 17.366 10.425 17.616 10.6416C18.1993 11.175 18.9743 11.5 19.8327 11.5C20.1993 11.5 20.5493 11.4416 20.8743 11.325C21.2743 12.275 21.4993 13.325 21.4993 14.4167Z",
    stroke: "#32AAAC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 8.16634C23.1667 8.43301 23.1333 8.69133 23.0667 8.94133C22.9917 9.27467 22.8583 9.59967 22.6833 9.88301C22.2833 10.558 21.6417 11.083 20.875 11.3247C20.55 11.4413 20.2 11.4997 19.8333 11.4997C18.975 11.4997 18.2 11.1746 17.6167 10.6413C17.3667 10.4246 17.15 10.1663 16.9833 9.88301C16.675 9.38301 16.5 8.79134 16.5 8.16634C16.5 7.79967 16.5583 7.44967 16.6667 7.11633C16.825 6.633 17.0917 6.19969 17.4417 5.84136C18.05 5.21636 18.9 4.83301 19.8333 4.83301C20.8167 4.83301 21.7083 5.25802 22.3083 5.94136C22.8417 6.53302 23.1667 7.31634 23.1667 8.16634Z",
    stroke: "#32AAAC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0751 8.15039H18.5918",
    stroke: "#32AAAC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.834 6.93359V9.42525",
    stroke: "#32AAAC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 3.5,
    stroke: "#32AAAC",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorSignupClrIcon);
export default __webpack_public_path__ + "static/media/tutor-signup-clr-icon.cb8a9ea5260ebea28a3f5dd39427465a.svg";
export { ForwardRef as ReactComponent };